import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type {
  IApiCrowdSearchRequestBody,
  IApiCrowdSearchResponseBody,
} from '../CrowdApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseSearchCrowdQueryValues = {
  appId: string;
  body?: IApiCrowdSearchRequestBody;
};

export const searchCrowdQueryKeyFactory: IQueryKeyFactory<
  IUseSearchCrowdQueryValues
> = (values) =>
  values &&
  (values.body
    ? (['searchCrowd', values.appId, values.body] as const)
    : (['searchCrowd', values.appId] as const));

export const useSearchCrowdQuery = (
  values?: IUseSearchCrowdQueryValues,
  options?: UseQueryOptions<IApiCrowdSearchResponseBody, ApiError>,
): UseQueryResult<IApiCrowdSearchResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: searchCrowdQueryKeyFactory(values),
    queryFn: values
      ? () => api.crowd.search(values.appId, values.body)
      : undefined,
    ...options,
  });
};
